<template>
  <g>
    <path
      d="M20 7.00018V19.0002C20 19.5502 19.55 20.0002 19 20.0002H7C6.45 20.0002 6 20.4502 6 21.0002C6 21.5502 6.45 22.0002 7 22.0002H20C21.1 22.0002 22 21.1002 22 20.0002V7.00018C22 6.45018 21.55 6.00018 21 6.00018C20.45 6.00018 20 6.45018 20 7.00018Z"
    />
    <path
      d="M16 2.00018H4C2.9 2.00018 2 2.90018 2 4.00018V16.0002C2 17.1002 2.9 18.0002 4 18.0002H16C17.1 18.0002 18 17.1002 18 16.0002V4.00018C18 2.90018 17.1 2.00018 16 2.00018ZM9 16.0002H4V11.0002H9V16.0002ZM16 16.0002H11V11.0002H16V16.0002ZM16 9.00018H4V4.00018H16V9.00018Z"
    />
  </g>
</template>
